<template>
	<Card class="relative cursor-pointer transition-all duration-200 hover:shadow-md border-1" :class="{
		'border-primary !ring-2 ring-primary/20 !bg-primary/5': selectedRender,
		'border-gray-200 dark:border-gray-700 hover:!border-gray-300 dark:hover:!border-gray-600': !selectedRender
	}" @click="$emit('update:modelValue', !modelValue)" @mouseover="hovering = true" @mouseleave="hovering = false">

		<template #content>
			<!-- Selection indicator -->
			<div class="absolute top-3 right-3">
				<i class="pi text-lg"
					:class="selectedRender ? 'pi-check-circle text-primary' : 'pi-circle text-gray-400'" />
			</div>

			<div class="space-y-4 pr-8">
				<!-- Header with name -->
				<div class="space-y-2">
					<h3 class="font-semibold text-lg text-gray-900 dark:text-gray-100">
						{{ chore.name }}
					</h3>

					<!-- Category and Difficulty -->
					<div class="flex items-center gap-2 flex-wrap">
						<Badge :value="$t('difficultyLevels.' + chore?.difficultyLevel)" severity="secondary" />
						<Badge v-if="chore.categoryName" :value="chore.categoryName" />
					</div>
				</div>

				<!-- Description -->
				<p class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
					{{ chore.description }}
				</p>

				<!-- Time and schedule info -->
				<div class="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
					<span class="flex items-center gap-1">
						<i class="pi pi-clock text-xs"></i>
						{{ chore.estimatedMinutes }} min
					</span>
					<span v-if="chore.autoSchedule" class="flex items-center gap-1 text-primary font-medium">
						<i class="pi pi-replay text-xs"></i>
						{{ $t('recurrenceIntervalTypes.' + chore.recurrenceInterval!) }}
					</span>
				</div>
			</div>
		</template>
	</Card>
</template>

<script setup lang="ts">
import type { NewChore } from '@/types';
import { computed, ref } from "vue";

const props = defineProps<{
	chore: NewChore;
	modelValue: boolean;
}>();

const hovering = ref(false);

const selectedRender = computed(() => hovering.value || props.modelValue);

defineEmits<{
	(e: 'update:modelValue', value: boolean): void;
}>();

</script>

<style scoped>
/* Custom styles if needed in the future */
</style>
